export default "__VITE_ASSET__DWLqd5PY__"